import * as monaco from 'monaco-editor';
import {
  HoverRequest,
  ProtocolConnection,
  ServerCapabilities,
} from 'vscode-languageserver-protocol';

import { hoverMapper, positionMapping } from '../utils/convertVscodeToMonaco';

export function hoverProvider(
  languageId: string,
  connection: ProtocolConnection,
  hoverOptions: ServerCapabilities['hoverProvider'],
) {
  if (hoverOptions === undefined || hoverOptions === false) return;

  if (hoverOptions !== true) {
    // TODO: what does this do?
    // capabilities.hoverProvider.workDoneProgress;
  }
  monaco.languages.registerHoverProvider(languageId, {
    async provideHover(model, position, token) {
      const result = await connection.sendRequest(
        HoverRequest.type,
        {
          textDocument: { uri: model.uri.toString(true) },
          position: positionMapping.monacoToVscode(position),
        },
        token,
      );
      return result ? hoverMapper.vscodeToMonaco(result) : null;
    },
  });
}
